import { BRANDS, BRANDS_WTH_SUBBRANDS } from '~~/constants/brands';
import type { BrandInfo, BrandKey } from '~~/constants/brands';

const isBrandKey = (name: string): name is BrandKey => {

  return (name in BRANDS);

};

const getSubBrandKey = (name: string): BrandKey | undefined => {

  return BRANDS_WTH_SUBBRANDS.find(brandWithSubbrand => name.startsWith(brandWithSubbrand));

};

export const getBrandKey = (name: string): BrandKey | undefined => {

  return isBrandKey(name) ? name : getSubBrandKey(name);

};

export const getBrandInfo = (productBrand: string | undefined): BrandInfo | undefined => {

  if (!productBrand) {

    return;

  }

  const brandKey = getBrandKey(productBrand);

  if (!brandKey) {

    return;

  }

  const brandInfo = BRANDS[brandKey];

  if (!brandInfo) {

    return;

  }

  return { name: productBrand, ...brandInfo };

};
